var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timestampShowFlag)?_c('div',{staticClass:"message-timestamp"},[_vm._v(" "+_vm._s(_vm.timestampShowContent)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }